// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.person.StopPrescriptionRequest */
/* istanbul ignore next */
@GandalfModel
export class StopPrescriptionRequest extends GandalfModelBase {

	@GandalfValidator({ sizeString: { message: 'Comments cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfValidator({ notNull: { message: 'Prescription is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	prescriptionId!: number;

	@GandalfValidator({ notNull: { message: 'Reason is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	reasonId!: number;

	@GandalfValidator({ notNull: { message: 'Stop Date is required' } })
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date, isRequired: true })
	stopDate!: Date;

}
